var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DirectShareAction, getUpdateSurveyActionDirectShare, updateSurveyDirectSharingToDirectSharing, updateSurveyDirectSharingToExistingFolderWithoutSharing, updateSurveyDirectSharingToExistingFolderWithSharing, updateSurveyDirectSharingToNewFolderWithoutSharing, updateSurveyDirectSharingToNewFolderWithSharing, } from "./update-survey-helper-direct-share";
import { FolderAction, getUpdateSurveyActionFolder, updateSurveyFolderToExistingFolderWithoutSharing, updateSurveyFolderToExistingFolderWithSharing, updateSurveyFolderToNewFolderWithoutSharing, updateSurveyFolderToNewFolderWithSharing, updateSurveySameFolderWithoutSharing, updateSurveySameFolderWithSharing, } from "./update-survey-helper-folder";
import { getUpdateSurveyActionNoDirectShareNoFolder, NoDirectShareNoFolderAction, updateSurveyNoShareNoFolderToDirectSharing, updateSurveyNoShareNoFolderToExistingFolderWithoutSharing, updateSurveyNoShareNoFolderToExistingFolderWithSharing, updateSurveyNoShareNoFolderToNewFolderWithoutSharing, updateSurveyNoShareNoFolderToNewFolderWithSharing, updateSurveyNoShareNoFolderToNoShareNoFolder, } from "./update-survey-helper-no-share-no-folder";
var UpdateSurveyInitialState;
(function (UpdateSurveyInitialState) {
    UpdateSurveyInitialState[UpdateSurveyInitialState["DirectShare"] = 0] = "DirectShare";
    UpdateSurveyInitialState[UpdateSurveyInitialState["Folder"] = 1] = "Folder";
    UpdateSurveyInitialState[UpdateSurveyInitialState["NoDirectShareNoFolder"] = 2] = "NoDirectShareNoFolder";
})(UpdateSurveyInitialState || (UpdateSurveyInitialState = {}));
var getInitialSurveyState = function (surveyDetail) {
    var _a;
    if (surveyDetail === null || surveyDetail === void 0 ? void 0 : surveyDetail.folderId) {
        return UpdateSurveyInitialState.Folder;
    }
    else if (((_a = surveyDetail === null || surveyDetail === void 0 ? void 0 : surveyDetail.sharedWithCount) !== null && _a !== void 0 ? _a : 0) > 0) {
        return UpdateSurveyInitialState.DirectShare;
    }
    else {
        return UpdateSurveyInitialState.NoDirectShareNoFolder;
    }
};
var updateSurveyNoDirectShareNoFolder = function (id, newFolderName, request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, setSurveyContacts, updateFolders, selectedSurvey) { return __awaiter(void 0, void 0, void 0, function () {
    var _collaborators, _collaboratorsToRemove, updateSurveyAction, _a, error_1, error_2, error_3, error_4, error_5, error_6;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _collaborators = ((_b = collaborators === null || collaborators === void 0 ? void 0 : collaborators.length) !== null && _b !== void 0 ? _b : 0) > 0 ? collaborators : undefined;
                _collaboratorsToRemove = ((_c = collaboratorsToRemove === null || collaboratorsToRemove === void 0 ? void 0 : collaboratorsToRemove.length) !== null && _c !== void 0 ? _c : 0) > 0 ? collaboratorsToRemove : undefined;
                updateSurveyAction = getUpdateSurveyActionNoDirectShareNoFolder(newFolderName, request, _collaborators, _collaboratorsToRemove);
                _a = updateSurveyAction;
                switch (_a) {
                    case NoDirectShareNoFolderAction.NewFolderWithSharing: return [3 /*break*/, 1];
                    case NoDirectShareNoFolderAction.NewFolderWithoutSharing: return [3 /*break*/, 5];
                    case NoDirectShareNoFolderAction.ExistingFolderWithSharing: return [3 /*break*/, 9];
                    case NoDirectShareNoFolderAction.ExistingFolderWithoutSharing: return [3 /*break*/, 12];
                    case NoDirectShareNoFolderAction.DirectShare: return [3 /*break*/, 15];
                    case NoDirectShareNoFolderAction.NoDirectShareNoFolder: return [3 /*break*/, 18];
                }
                return [3 /*break*/, 21];
            case 1:
                _d.trys.push([1, 4, , 5]);
                if (!newFolderName) return [3 /*break*/, 3];
                return [4 /*yield*/, updateSurveyNoShareNoFolderToNewFolderWithSharing(id, newFolderName, request, collaborators, getSubjectsFromContacts, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, setSurveyContacts, selectedSurvey)];
            case 2:
                _d.sent();
                _d.label = 3;
            case 3: return [3 /*break*/, 21];
            case 4:
                error_1 = _d.sent();
                console.error("Error in updating survey with new folder/collaborators: ", error_1);
                return [3 /*break*/, 5];
            case 5:
                _d.trys.push([5, 8, , 9]);
                if (!newFolderName) return [3 /*break*/, 7];
                return [4 /*yield*/, updateSurveyNoShareNoFolderToNewFolderWithoutSharing(id, newFolderName, request, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, selectedSurvey)];
            case 6:
                _d.sent();
                _d.label = 7;
            case 7: return [3 /*break*/, 21];
            case 8:
                error_2 = _d.sent();
                console.error("Error in updating survey with new folder/no collaborators: ", error_2);
                return [3 /*break*/, 9];
            case 9:
                _d.trys.push([9, 11, , 12]);
                return [4 /*yield*/, updateSurveyNoShareNoFolderToExistingFolderWithSharing(id, request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, updateFolders, updateSurvey, setSurveys, setSelectedSurvey, setSurveyContacts, selectedSurvey)];
            case 10:
                _d.sent();
                return [3 /*break*/, 21];
            case 11:
                error_3 = _d.sent();
                console.error("Error in updating survey with existing folder/collaborators: ", error_3);
                return [3 /*break*/, 12];
            case 12:
                _d.trys.push([12, 14, , 15]);
                return [4 /*yield*/, updateSurveyNoShareNoFolderToExistingFolderWithoutSharing(id, request, updateSurvey, setSurveys, setSelectedSurvey, selectedSurvey)];
            case 13:
                _d.sent();
                return [3 /*break*/, 21];
            case 14:
                error_4 = _d.sent();
                console.error("Error in updating survey with existing folder/ no collaborators: ", error_4);
                return [3 /*break*/, 15];
            case 15:
                _d.trys.push([15, 17, , 18]);
                return [4 /*yield*/, updateSurveyNoShareNoFolderToDirectSharing(id, request, collaborators, getSubjectsFromContacts, updateSurvey, setSurveys, setSelectedSurvey, setSurveyContacts, selectedSurvey)];
            case 16:
                _d.sent();
                return [3 /*break*/, 21];
            case 17:
                error_5 = _d.sent();
                console.error("Error in updating survey with direct sharing: ", error_5);
                return [3 /*break*/, 18];
            case 18:
                _d.trys.push([18, 20, , 21]);
                return [4 /*yield*/, updateSurveyNoShareNoFolderToNoShareNoFolder(id, request, updateSurvey, setSurveys, setSelectedSurvey, selectedSurvey)];
            case 19:
                _d.sent();
                return [3 /*break*/, 21];
            case 20:
                error_6 = _d.sent();
                console.error("Error in updating survey with no direct sharing/no folders: ", error_6);
                return [3 /*break*/, 21];
            case 21: return [2 /*return*/];
        }
    });
}); };
var updateSurveyFolder = function (id, newFolderName, request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, setSurveyContacts, updateFolders, selectedSurvey, removeSavedSearchFromFolder) { return __awaiter(void 0, void 0, void 0, function () {
    var _collaborators, _collaboratorsToRemove, updateSurveyAction, _a, error_7, error_8, error_9, error_10, error_11, error_12;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _collaborators = ((_b = collaborators === null || collaborators === void 0 ? void 0 : collaborators.length) !== null && _b !== void 0 ? _b : 0) > 0 ? collaborators : undefined;
                _collaboratorsToRemove = ((_c = collaboratorsToRemove === null || collaboratorsToRemove === void 0 ? void 0 : collaboratorsToRemove.length) !== null && _c !== void 0 ? _c : 0) > 0 ? collaboratorsToRemove : undefined;
                updateSurveyAction = getUpdateSurveyActionFolder(newFolderName, request, _collaborators, _collaboratorsToRemove, selectedSurvey);
                _a = updateSurveyAction;
                switch (_a) {
                    case FolderAction.NewFolderWithSharing: return [3 /*break*/, 1];
                    case FolderAction.NewFolderWithoutSharing: return [3 /*break*/, 5];
                    case FolderAction.ExistingFolderWithSharing: return [3 /*break*/, 9];
                    case FolderAction.ExistingFolderWithoutSharing: return [3 /*break*/, 12];
                    case FolderAction.SameFolderWithSharing: return [3 /*break*/, 15];
                    case FolderAction.SameFolderWithoutSharing: return [3 /*break*/, 18];
                }
                return [3 /*break*/, 21];
            case 1:
                _d.trys.push([1, 4, , 5]);
                if (!newFolderName) return [3 /*break*/, 3];
                return [4 /*yield*/, updateSurveyFolderToNewFolderWithSharing(id, newFolderName, request, collaborators, getSubjectsFromContacts, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, setSurveyContacts, selectedSurvey, removeSavedSearchFromFolder)];
            case 2:
                _d.sent();
                _d.label = 3;
            case 3: return [3 /*break*/, 21];
            case 4:
                error_7 = _d.sent();
                console.error("Error in updating survey with new folder/collaborators: ", error_7);
                return [3 /*break*/, 5];
            case 5:
                _d.trys.push([5, 8, , 9]);
                if (!newFolderName) return [3 /*break*/, 7];
                return [4 /*yield*/, updateSurveyFolderToNewFolderWithoutSharing(id, newFolderName, request, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, selectedSurvey, removeSavedSearchFromFolder)];
            case 6:
                _d.sent();
                _d.label = 7;
            case 7: return [3 /*break*/, 21];
            case 8:
                error_8 = _d.sent();
                console.error("Error in updating survey with new folder/no collaborators: ", error_8);
                return [3 /*break*/, 9];
            case 9:
                _d.trys.push([9, 11, , 12]);
                return [4 /*yield*/, updateSurveyFolderToExistingFolderWithSharing(id, request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, updateFolders, updateSurvey, setSurveys, setSelectedSurvey, setSurveyContacts, selectedSurvey, removeSavedSearchFromFolder)];
            case 10:
                _d.sent();
                return [3 /*break*/, 21];
            case 11:
                error_9 = _d.sent();
                console.error("Error in updating survey with existing folder/collaborators: ", error_9);
                return [3 /*break*/, 12];
            case 12:
                _d.trys.push([12, 14, , 15]);
                return [4 /*yield*/, updateSurveyFolderToExistingFolderWithoutSharing(id, request, updateSurvey, setSurveys, setSelectedSurvey, selectedSurvey, removeSavedSearchFromFolder)];
            case 13:
                _d.sent();
                return [3 /*break*/, 21];
            case 14:
                error_10 = _d.sent();
                console.error("Error in updating survey with existing folder/ no collaborators: ", error_10);
                return [3 /*break*/, 15];
            case 15:
                _d.trys.push([15, 17, , 18]);
                return [4 /*yield*/, updateSurveySameFolderWithSharing(id, request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, updateSurvey, setSurveys, setSelectedSurvey, setSurveyContacts, selectedSurvey, updateFolders)];
            case 16:
                _d.sent();
                return [3 /*break*/, 21];
            case 17:
                error_11 = _d.sent();
                console.error("Error in updating survey with same folder + sharing: ", error_11);
                return [3 /*break*/, 18];
            case 18:
                _d.trys.push([18, 20, , 21]);
                return [4 /*yield*/, updateSurveySameFolderWithoutSharing(id, request, updateSurvey, setSurveys, setSelectedSurvey, selectedSurvey)];
            case 19:
                _d.sent();
                return [3 /*break*/, 21];
            case 20:
                error_12 = _d.sent();
                console.error("Error in updating survey with same folder + no sharing: ", error_12);
                return [3 /*break*/, 21];
            case 21: return [2 /*return*/];
        }
    });
}); };
var updateSurveyDirectSharing = function (id, newFolderName, request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, setSurveyContacts, updateFolders, selectedSurvey, removeSurveyFromSharing, getSurveyDirectSharingCollaborators) { return __awaiter(void 0, void 0, void 0, function () {
    var _collaborators, _collaboratorsToRemove, updateSurveyAction, _a, error_13, error_14, error_15, error_16, error_17;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _collaborators = ((_b = collaborators === null || collaborators === void 0 ? void 0 : collaborators.length) !== null && _b !== void 0 ? _b : 0) > 0 ? collaborators : undefined;
                _collaboratorsToRemove = ((_c = collaboratorsToRemove === null || collaboratorsToRemove === void 0 ? void 0 : collaboratorsToRemove.length) !== null && _c !== void 0 ? _c : 0) > 0 ? collaboratorsToRemove : undefined;
                updateSurveyAction = getUpdateSurveyActionDirectShare(newFolderName, request, _collaborators, _collaboratorsToRemove);
                _a = updateSurveyAction;
                switch (_a) {
                    case DirectShareAction.NewFolderWithSharing: return [3 /*break*/, 1];
                    case DirectShareAction.NewFolderWithoutSharing: return [3 /*break*/, 5];
                    case DirectShareAction.ExistingFolderWithSharing: return [3 /*break*/, 9];
                    case DirectShareAction.ExistingFolderWithoutSharing: return [3 /*break*/, 12];
                    case DirectShareAction.DirectSharing: return [3 /*break*/, 15];
                }
                return [3 /*break*/, 18];
            case 1:
                _d.trys.push([1, 4, , 5]);
                if (!newFolderName) return [3 /*break*/, 3];
                return [4 /*yield*/, updateSurveyDirectSharingToNewFolderWithSharing(id, newFolderName, request, collaborators, getSubjectsFromContacts, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, setSurveyContacts, selectedSurvey, removeSurveyFromSharing, getSurveyDirectSharingCollaborators)];
            case 2:
                _d.sent();
                _d.label = 3;
            case 3: return [3 /*break*/, 18];
            case 4:
                error_13 = _d.sent();
                console.error("Error in updating survey with new folder/collaborators: ", error_13);
                return [3 /*break*/, 5];
            case 5:
                _d.trys.push([5, 8, , 9]);
                if (!newFolderName) return [3 /*break*/, 7];
                return [4 /*yield*/, updateSurveyDirectSharingToNewFolderWithoutSharing(id, newFolderName, request, createSavedSearchFolder, updateSurvey, setFolders, setSurveys, setSelectedSurvey, selectedSurvey, removeSurveyFromSharing, getSurveyDirectSharingCollaborators)];
            case 6:
                _d.sent();
                _d.label = 7;
            case 7: return [3 /*break*/, 18];
            case 8:
                error_14 = _d.sent();
                console.error("Error in updating survey with new folder/no collaborators: ", error_14);
                return [3 /*break*/, 9];
            case 9:
                _d.trys.push([9, 11, , 12]);
                return [4 /*yield*/, updateSurveyDirectSharingToExistingFolderWithSharing(id, request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, updateFolders, updateSurvey, setSurveys, setSelectedSurvey, setSurveyContacts, selectedSurvey, removeSurveyFromSharing, getSurveyDirectSharingCollaborators)];
            case 10:
                _d.sent();
                return [3 /*break*/, 18];
            case 11:
                error_15 = _d.sent();
                console.error("Error in updating survey with existing folder/collaborators: ", error_15);
                return [3 /*break*/, 12];
            case 12:
                _d.trys.push([12, 14, , 15]);
                return [4 /*yield*/, updateSurveyDirectSharingToExistingFolderWithoutSharing(id, request, updateSurvey, setSurveys, setSelectedSurvey, selectedSurvey, removeSurveyFromSharing, getSurveyDirectSharingCollaborators)];
            case 13:
                _d.sent();
                return [3 /*break*/, 18];
            case 14:
                error_16 = _d.sent();
                console.error("Error in updating survey with existing folder/ no collaborators: ", error_16);
                return [3 /*break*/, 15];
            case 15:
                _d.trys.push([15, 17, , 18]);
                return [4 /*yield*/, updateSurveyDirectSharingToDirectSharing(id, request, collaborators, collaboratorsToRemove, getSubjectsFromContacts, updateSurvey, setSurveys, setSelectedSurvey, setSurveyContacts, selectedSurvey, getSurveyDirectSharingCollaborators)];
            case 16:
                _d.sent();
                return [3 /*break*/, 18];
            case 17:
                error_17 = _d.sent();
                console.error("Error in updating survey with direct sharing: ", error_17);
                return [3 /*break*/, 18];
            case 18: return [2 /*return*/];
        }
    });
}); };
export { getInitialSurveyState, UpdateSurveyInitialState, getUpdateSurveyActionNoDirectShareNoFolder, updateSurveyNoDirectShareNoFolder, updateSurveyFolder, updateSurveyDirectSharing, };
//# sourceMappingURL=update-survey-helper.js.map